var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUploadSimple = function SvgIconUploadSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.293 3.043a1 1 0 0 1 1.414 0l3.938 3.937a1 1 0 0 1-1.415 1.415L13 6.165v8.085a1 1 0 1 1-2 0V6.164l-2.23 2.23A1 1 0 0 1 7.355 6.98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 13.25a1 1 0 0 1 1 1v5h14.5v-5a1 1 0 1 1 2 0v5.25a1.75 1.75 0 0 1-1.75 1.75h-15a1.75 1.75 0 0 1-1.75-1.75v-5.25a1 1 0 0 1 1-1"
  }))));
};
export default SvgIconUploadSimple;